module.exports = __webpack_public_path__ + "fonts/Gilroy-200.7c721d9.otf";